// Project Imports
import INCOME_TYPE_ENUM from "constants/incomeTypeEnum";
import chooseNeedInitialDropdownValues from "./chooseNeedDropDownInitialConstant";
import getCookie from "utils/journeyIdCookie/getJourneyId";
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "constants/Constants";
import utils from "./utils";

const formObserver = (formController) => {
  formController.$("protection_for_my_family.target_amount_type").observe({
    key: "value",
    call: async ({ form, field }) => {

      let type = field.value.mode;
      let journey_id = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)

      let lumpsumList = form.$("protection_for_my_family.target_amount_dropdown").extra?.allOptionsList ?  form.$("protection_for_my_family.target_amount_dropdown").extra?.allOptionsList.filter(item => item?.mode === INCOME_TYPE_ENUM.LUMPSUM) : []

      if (type === INCOME_TYPE_ENUM.LUMPSUM) {
        form.$("protection_for_my_family.target_amount_dropdown").set("extra", {
          ...form.$("protection_for_my_family.target_amount_dropdown").extra,
          optionList: lumpsumList,
        })

        form.$("protection_for_my_family.target_amount_dropdown").set("type", "text")
        form.$("protection_for_my_family.target_amount_value").set("type", "text")


        const defaultTargetAmountValue = lumpsumList.find(item => item.label === chooseNeedInitialDropdownValues.protectionForFamilyLumpsum)

        form.$("protection_for_my_family.target_amount_dropdown").set("value", defaultTargetAmountValue)

        if (journey_id) {
          let productList = form.$("protection_for_my_family.products_list").extra.preDefinedOptList
          let filterProductList = productList.filter(item => item.payout_type.toLowerCase() === INCOME_TYPE_ENUM.LUMPSUM.toLowerCase())
          // let productsList = await utils.getProductList(4, "lumpsum")
          form.$("protection_for_my_family.products_list").set("extra", {
            ...form.$("protection_for_my_family.products_list").extra,
            optionList: filterProductList
          })
          // form.$("protection_for_my_family.products_list").set("value", filterProductList[0])
        }


      } else {

        form.$("protection_for_my_family.target_amount_value").set("type", "hidden")
        form.$("protection_for_my_family.target_amount_dropdown").set("type", "hidden")

        if (journey_id) {
          let productList = await form.$("protection_for_my_family.products_list").extra.preDefinedOptList
          let filterProductList = productList.filter(item => item.payout_type.toLowerCase() === INCOME_TYPE_ENUM.LUMPSUM.toLowerCase())
          // let productsList = await utils.getProductList(4, "lumpsum")
          form.$("protection_for_my_family.products_list").set("extra", {
            ...form.$("protection_for_my_family.products_list").extra,
            optionList: filterProductList
          })
          // form.$("protection_for_my_family.products_list").set("value", filterProductList[0])
        }
      }
      //form.$("protection_for_my_family.target_amount_value").set("type", "hidden")
      //form.$("protection_for_my_family.target_amount_value").value = ""
    },
  });

  formController.$("protection_for_my_family.target_amount_dropdown").observe({
    key: "value",
    call: ({ form, field }) => {
      let mid_value = field.value.mid_value;
      form.$("protection_for_my_family.target_amount_value").set("value", mid_value)
    }
  });

  formController.$("grow_my_money.target_amount_type").observe({
    key: "value",
    call: async ({ form, field }) => {
      let type = field.value.mode;
      let journey_id = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)

      form.$("grow_my_money.target_amount_dropdown").value = {}

      let incomeList = form.$("grow_my_money.target_amount_dropdown").extra.allOptionsList.filter(item => item.mode === INCOME_TYPE_ENUM.INCOME)

      let lumpsumList = form.$("grow_my_money.target_amount_dropdown").extra.allOptionsList.filter(item => item.mode === INCOME_TYPE_ENUM.LUMPSUM)
  
      if (type === INCOME_TYPE_ENUM.INCOME) {
        form.$("grow_my_money.target_amount_dropdown").set("extra", {
          ...form.$("grow_my_money.target_amount_dropdown").extra,
          optionList: incomeList,
        }
        )

        const defaultTargetAmountValue = incomeList.find(item => item.label === chooseNeedInitialDropdownValues.growMyMoneyIncome)

        form.$("grow_my_money.target_amount_dropdown").set("value", defaultTargetAmountValue)
        if (journey_id) {
          let productList = form.$("grow_my_money.products_list").extra.preDefinedOptList
          let filterProductList = productList.filter(item => item.payout_type.toLowerCase() === INCOME_TYPE_ENUM.INCOME.toLowerCase())
          // let productsList = await utils.getProductList(1, "income")
          form.$("grow_my_money.products_list").set("extra", {
            ...form.$("grow_my_money.products_list").extra,
            optionList: filterProductList
          })
          // form.$("grow_my_money.products_list").set("value", filterProductList[0])
        }
      }

      if (type === INCOME_TYPE_ENUM.LUMPSUM) {
        
        form.$("grow_my_money.target_amount_dropdown").set("extra", {
          ...form.$("grow_my_money.target_amount_dropdown").extra,
          optionList: lumpsumList,
        })
        const defaultTargetAmountValue = lumpsumList.find(item => item.label === chooseNeedInitialDropdownValues.growMyMoneyLumpsum)

        form.$("grow_my_money.target_amount_dropdown").set("value", defaultTargetAmountValue)

        if (journey_id) {

          let productList = form.$("grow_my_money.products_list").extra.preDefinedOptList
          
          let filterProductList = productList.filter(item => item.payout_type.toLowerCase() === INCOME_TYPE_ENUM.LUMPSUM.toLowerCase())
          // let productsList = await utils.getProductList(1, "lumpsum")
          form.$("grow_my_money.products_list").set("extra", {
            ...form.$("grow_my_money.products_list").extra,
            optionList: filterProductList
          })
          // form.$("grow_my_money.products_list").set("value", filterProductList[0])
        }

      }
    }
  });

  formController.$("grow_my_money.target_amount_dropdown").observe({
    key: "value",
    call: ({ form, field }) => {
      let mid_value = field.value.mid_value;
      form.$("grow_my_money.target_amount_value").set("value", mid_value)
    }
  });

  formController.$("save_for_children.target_amount_type").observe({
    key: "value",
    call: async ({ form, field }) => {
      let type = field.value.mode;
      let journey_id = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)

      form.$("save_for_children.target_amount_dropdown").value = {}
      let incomeList = form.$("save_for_children.target_amount_dropdown").extra.allOptionsList.filter(item => item.mode === INCOME_TYPE_ENUM.INCOME)

      let lumpsumList = form.$("save_for_children.target_amount_dropdown").extra.allOptionsList.filter(item => item.mode === INCOME_TYPE_ENUM.LUMPSUM)

      if (type === INCOME_TYPE_ENUM.INCOME) {
        form.$("save_for_children.target_amount_dropdown").set("extra", {
          ...form.$("save_for_children.target_amount_dropdown").extra,
          optionList: incomeList,
        })

        const defaultTargetAmountValue = incomeList.find(item => item.label === chooseNeedInitialDropdownValues.saveForChildrenIncome)

        form.$("save_for_children.target_amount_dropdown").set("value", defaultTargetAmountValue)


         if (journey_id) {
          let productList = form.$("save_for_children.products_list").extra.preDefinedOptList
          let filterProductList = productList.filter(item => item.payout_type.toLowerCase() === INCOME_TYPE_ENUM.INCOME.toLowerCase())
          // let productsList = await utils.getProductList(4, "lumpsum")
          form.$("save_for_children.products_list").set("extra", {
            ...form.$("save_for_children.products_list").extra,
            optionList: filterProductList
          })
          // form.$("save_for_children.products_list").set("value", filterProductList[0])
        }
      }
      if (type === INCOME_TYPE_ENUM.LUMPSUM) {
        form.$("save_for_children.target_amount_dropdown").set("extra", {
          ...form.$("save_for_children.target_amount_dropdown").extra,
          optionList: lumpsumList,
        })

        const defaultTargetAmountValue = lumpsumList.find(item => item.label === chooseNeedInitialDropdownValues.saveForChildrenLumpsum)

        form.$("save_for_children.target_amount_dropdown").set("value", defaultTargetAmountValue)


        if (journey_id) {
          let productList = form.$("save_for_children.products_list").extra.preDefinedOptList
          let filterProductList = productList.filter(item => item.payout_type.toLowerCase() === INCOME_TYPE_ENUM.LUMPSUM.toLowerCase())
          // let productsList = await utils.getProductList(4, "lumpsum")
          form.$("save_for_children.products_list").set("extra", {
            ...form.$("save_for_children.products_list").extra,
            optionList: filterProductList
          })
          // form.$("save_for_children.products_list").set("value", filterProductList[0])
        }
      }
    }
  });

  formController.$("save_for_children.target_amount_dropdown").observe({
    key: "value",
    call: ({ form, field }) => {
      let mid_value = field.value.mid_value;
      form.$("save_for_children.target_amount_value").set("value", mid_value)
    }
  });

  formController.$("save_for_retirement.target_amount_type").observe({
    key: "value",
    call: async ({ form, field }) => {

      let type = field.value.mode;
      let journey_id = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)

      let incomeList = form.$("save_for_retirement.target_amount_dropdown").extra.optionList

      if (type === INCOME_TYPE_ENUM.INCOME) {
        form.$("save_for_retirement.target_amount_dropdown").set("extra", {
          ...form.$("save_for_retirement.target_amount_dropdown").extra,
          optionList: incomeList,
        })

        form.$("save_for_retirement.target_amount_dropdown").set("type", "text")
        form.$("save_for_retirement.target_amount_value").set("type", "text")
        const defaultTargetAmountValue = incomeList.find(item => item.label === chooseNeedInitialDropdownValues.saveForRetirementIncome)

        form.$("save_for_retirement.target_amount_dropdown").set("value", defaultTargetAmountValue)

        if (journey_id) {
          let productList = form.$("save_for_retirement.products_list").extra.preDefinedOptList
          let filterProductList = productList.filter(item => item.payout_type.toLowerCase() === INCOME_TYPE_ENUM.INCOME.toLowerCase())
          // let productsList = await utils.getProductList(4, "lumpsum")
          form.$("save_for_retirement.products_list").set("extra", {
            ...form.$("save_for_retirement.products_list").extra,
            optionList: filterProductList
          })
          //form.$("save_for_retirement.products_list").set("value", filterProductList[0])
        }


      } else {
        form.$("save_for_retirement.target_amount_value").set("type", "hidden")
        form.$("save_for_retirement.target_amount_dropdown").set("type", "hidden")

        if (journey_id) {
          let productList = form.$("save_for_retirement.products_list").extra.preDefinedOptList
          let filterProductList = productList.filter(item => item.payout_type.toLowerCase() === INCOME_TYPE_ENUM.LUMPSUM.toLowerCase())
          // let productsList = await utils.getProductList(4, "lumpsum")
          form.$("save_for_retirement.products_list").set("extra", {
            ...form.$("save_for_retirement.products_list").extra,
            optionList: filterProductList
          })
          // form.$("save_for_retirement.products_list").set("value", filterProductList[0])
        }
      }
      // form.$("save_for_retirement.target_amount_value").set("type", "")
      // form.$("save_for_retirement.target_amount_value").value = ""
    },
  });

  formController.$("save_for_retirement.target_amount_dropdown").observe({
    key: "value",
    call: ({ form, field }) => {
      let mid_value = field.value.mid_value;
      form.$("save_for_retirement.target_amount_value").set("value", mid_value)
    }
  });


};

export default formObserver;
